import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt'; // Import the JwtHelperService

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const jwtHelper = inject(JwtHelperService);
  const token = localStorage.getItem('token');

  if (token) {
    try {
      const decodedToken: any = jwtHelper.decodeToken(token);
      const userCode = decodedToken.UserCode;
      const userCodePattern = /^[A-F0-9\-]{36}$/;

      if (userCode && userCodePattern.test(userCode)) {
        return true;
      } else {
        router.navigate(['/login']);
        return false;
      }
    } catch (error) {
      console.error('Invalid token:', error);
      router.navigate(['/login']);
      return false;
    }
  } else {
    router.navigate(['/login']);
    return false;
  }
};
